import { Address } from './addressApiTypes';

export const mockGetDeliveryAddress: Address = {
  id: 1,
  addressLine1: 'U garáží 1',
  city: 'Wroclaw',
  country: 'PL',
  email: 'info@mall.pl',
  name: 'Józef Nowak',
  phone: '+48123456789',
  zip: '50-155',
};

export const mockGetBillingAddress: Address = {
  id: 1,
  addressLine1: 'Pražská 1',
  city: 'Praha 1',
  country: 'CZ',
  email: 'email@mail.cz',
  name: 'Petr Novák',
  phone: '+420123456789',
  zip: '10000',
};
